import { z } from 'zod';

/**
 * Envelope schemas mirroring the backend contract in `app/schemas/common.py`.
 * Responses are validated at the boundary so the rest of the app can trust its
 * types instead of casting.
 */

export const errorDetailSchema = z.object({
  code: z.string(),
  message: z.string(),
  details: z.record(z.unknown()).nullable().optional(),
});

export const errorResponseSchema = z.object({
  success: z.literal(false),
  error: errorDetailSchema,
});

export function successResponseSchema<T extends z.ZodTypeAny>(dataSchema: T) {
  return z.object({
    success: z.literal(true),
    data: dataSchema,
    message: z.string().nullable().optional(),
  });
}

export const pageMetaSchema = z.object({
  page: z.number(),
  size: z.number(),
  total: z.number(),
  pages: z.number(),
  has_next: z.boolean(),
  has_previous: z.boolean(),
});

export function pageSchema<T extends z.ZodTypeAny>(itemSchema: T) {
  return z.object({
    items: z.array(itemSchema),
    meta: pageMetaSchema,
  });
}

export type ErrorDetail = z.infer<typeof errorDetailSchema>;
export type PageMeta = z.infer<typeof pageMetaSchema>;
